module.exports = __webpack_public_path__ + "img/logo.888684b2.png";